import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'check-email',
  templateUrl: './check-email.component.html',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule],
})
export class CheckEmailComponent {
  @Output() childEvent = new EventEmitter<boolean>();

  toggleIsClicked() {
    this.childEvent.emit(false);
  }
}
